/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsDoubleNwSe = createReactComponent("outline", "arrows-double-nw-se", "IconArrowsDoubleNwSe", [["path", { "d": "M14 21l-11 -11", "key": "svg-0" }], ["path", { "d": "M3 14v-4h4", "key": "svg-1" }], ["path", { "d": "M17 14h4v-4", "key": "svg-2" }], ["path", { "d": "M10 3l11 11", "key": "svg-3" }]]);

export { IconArrowsDoubleNwSe as default };
//# sourceMappingURL=IconArrowsDoubleNwSe.mjs.map
